module.exports = __webpack_public_path__ + "linea-software-10.b5b4a545328f3eee2789.eot";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-software-10.eot
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-software-10.eot
// module chunks = styles